import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FeaturedEventsComponent } from './featured-events.component';

const routes: Routes = [
    {
        path: '',
        component: FeaturedEventsComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class FeaturedEventsRoutingModule { }
